import { useEffect, useState } from 'react'
import 'react-inner-image-zoom/lib/InnerImageZoom/styles.min.css'
import InnerImageZoom from 'react-inner-image-zoom'
import styled from 'styled-components'
import { ColorKey } from 'components/ColorKey'
import { getColorKeyEntries } from 'Content/CityDatas/sat_images/color_key_entries'
const isMobile = window.innerWidth < 712

var base_url = 'https://interaktiv.tagesanzeiger.ch/2024/SozIndex/munis/'

const ZoomableImage = ({
  gde,
  colorMode,
  labels,
  lang,
}: {
  gde: number
  colorMode: 'dark' | 'light' | undefined
  labels: any
  lang: 'de' | 'fr'
}) => {
  const [isValid, setIsValid] = useState<boolean>(true)
  const [loading, setLoading] = useState<boolean>(true)
  const checkImage = async (path: string) =>
    await new Promise((resolve) => {
      const img = new Image()
      img.onload = () => {
        setIsValid(true)
        setLoading(false)
        return resolve({ path, status: 'ok' })
      }
      img.onerror = () => {
        setIsValid(false)
        return resolve({ path, status: 'error' })
      }

      img.src = path
    })
  useEffect(() => {
    setLoading(true)
    checkImage(
      base_url + gde + (colorMode === 'dark' ? '_darkmode' : '') + '.png'
    )
  }, [gde, colorMode])
  return (
    <>
      {loading && (
        <NoGde>
          <span>Karte wird geladen.</span>
        </NoGde>
      )}
      {!isValid && (
        <NoGde>
          <span>Leider haben wir für diese Gemeinde keine Karte.</span>
        </NoGde>
      )}
      {isValid && !loading && (
        <>
          <ColorKey
            centered
            entries={getColorKeyEntries(colorMode, lang) as any}
            transparent
          />
          <ZoomWrapper>
            <InnerImageZoom
              moveType='pan'
              hasSpacer
              className='zoomableimage'
              zoomScale={isMobile ? 1.25 : 1.75}
              src={
                base_url +
                gde +
                (colorMode === 'dark' ? '_darkmode' : '') +
                '.png'
              }
            />
          </ZoomWrapper>
        </>
      )}
    </>
  )
}

const ZoomWrapper = styled.div`
  margin-top: 10px;
  .zoomableimage {
    overflow: hidden;
    img {
      margin-top: 0;
    }
    span {
      background-color: var(--brandblue-main);
      &::before {
        background-image: url(${require('./zoom.png')});
        background-size: contain;
      }
    }
    button {
      background-color: var(--brandblue-main);
      &::before {
        background-image: linear-gradient(#fff, #fff),
          linear-gradient(#fff, #fff);
      }
    }
  }
`

const NoGde = styled.div`
  font-size: 14px;
  line-height: 1.3em;
  padding: 15px;
  margin-left: 15px;
  margin-right: 15px;
  max-width: 100%;
  border: 1px solid var(--text-color);
  span {
    padding: 15px;
  }
`
export default ZoomableImage
